import React from 'react'

import { useChartLayoutGlobalModel } from './chart-layout-model'
import { ChartTab } from './chart-tab'
import { ColorsTab } from './colors-tab'
import { SettingsTab } from './constants'

interface ChartSettingsProps {
  onSubmit: () => void
  onClose: () => void
  onActiveSettingsTabChange?: (settingsComponent: SettingsTab) => void
  activeSettingsTab?: SettingsTab
}

export function ChartSettings({
  activeSettingsTab = SettingsTab.Chart,
  onSubmit,
  onClose,
  onActiveSettingsTabChange,
}: ChartSettingsProps) {
  const { generateNewLayoutModelConfigSnapshot } = useChartLayoutGlobalModel()
  const [activeTab, setActiveTab] = React.useState<SettingsTab>(activeSettingsTab)
  const ActiveComponent = React.useMemo(() => {
    if (activeTab === SettingsTab.Colors) {
      return ColorsTab
    }

    return ChartTab
  }, [activeTab])

  const handleChangeSettingsComponent = React.useCallback(
    (settingsType: SettingsTab) => {
      onActiveSettingsTabChange?.(settingsType)
      setActiveTab(settingsType)
    },
    [onActiveSettingsTabChange]
  )

  React.useEffect(() => {
    generateNewLayoutModelConfigSnapshot()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <ActiveComponent onClose={onClose} onSubmit={onSubmit} onChangeSettingsTab={handleChangeSettingsComponent} />
}
